import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "directionsFilled"
const DirectionsFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M10.875 1.5C11.29 1.5 11.625 1.836 11.625 2.25V6.75H18.73L21.943 10.675C22.394 11.227 22.394 12.023 21.942 12.575L19.181 15.95C18.896 16.298 18.47 16.5 18.021 16.5H11.624V21.75C11.625 22.164 11.29 22.5 10.875 22.5S10.125 22.164 10.125 21.75V9.75H5.935C5.539 9.75 5.158 9.592 4.876 9.31L2.25 6.687C1.665 6.1 1.665 5.15 2.25 4.564L4.875 1.94C5.157 1.66 5.538 1.5 5.935 1.5z" />
        </svg>
      }
    </span>
  )
}
export default DirectionsFilledIcon
